module.exports = __webpack_public_path__ + "img/product14.349b4e88.jpg";